// extracted by mini-css-extract-plugin
export default {"screenCardCommentsBadge":"AP__9iq_CCUQVcQqwyx9","count":"wjddGXBzCMcLqUYS6Ddy","hasUnreadComment":"fKTzVEVqAg4JhVejh0_Z"};